import { EventMappings } from './EventMappings';
import {
  ColumnKeys,
  FrontendEventCategories,
  FrontendEventTypes,
  FrontendRequirements,
  Office365EventType,
  OS,
  Sensors,
} from '../types';

export class Office365EventMappings extends EventMappings {
  public constructor(dependencies: { translateFn: Function }) {
    super(dependencies);
    this.sensorName = Sensors.OFFICE365;

    this.mappings = {
      [Office365EventType.MAIL]: {
        [ColumnKeys.EVENT_TYPE]: FrontendEventTypes.O365_MAIL,
        [ColumnKeys.CATEGORY]: FrontendEventCategories.O365,
        [ColumnKeys.OS_TYPES]: [OS.WINDOWS, OS.MAC, OS.LINUX],
        [ColumnKeys.REQUIREMENTS]: [FrontendRequirements.O365_MAIL],
      },
    };
  }
}
